export default __webpack_public_path__ + "static/media/response-icon.ae76c9ea.svg";